var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "docs.markdown.control",
  title: "Docs Markdown Control",
  description: "Markdown editor control for documentation authoring.",
  control: true,
  supportServer: false,
  fields: {
    name: {
      title: "Name",
      type: "string",
      description: "Control data key name.",
      required: true
    },
    inner: {
      title: "Markdown",
      type: "string",
      description: "Markdown content.",
      required: false
    },
    placeholder: {
      title: "Placeholder",
      type: "string",
      description: "Optional placeholder message.",
      required: false
    },
    rows: {
      title: "Rows",
      type: "number",
      description: "Initial row count for the editor textarea.",
      required: false
    }
  },
  passthrough: {
    except: ["inner", "name", "rows", "placeholder"]
  }
});

async function render(options) {
  var wrapper = document.createElement("section");
  wrapper.className = "docs-markdown-control";

  var textarea = document.createElement("textarea");
  textarea.setAttribute("data-role", "docs-markdown-input");
  textarea.value = options.inner || "";
  textarea.rows = Number(options.rows || 16);
  textarea.placeholder = options.placeholder || "Write markdown...";
  textarea.style.width = "100%";
  textarea.style.minHeight = "14rem";
  textarea.style.padding = "0.7rem";
  textarea.style.fontFamily = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace";

  wrapper.appendChild(textarea);

  return wrapper;
}
module.exports.render = render;

async function save(name, control) {
  var input = control ? control.querySelector('[data-role="docs-markdown-input"]') : null;
  var markdown = input ? input.value : "";

  return {
    success: true,
    namespace: "docs.markdown.control",
    data: {
      name: name,
      markdown: markdown
    }
  };
}
module.exports.save = save;

async function load(name, control, data) {
  var input = control ? control.querySelector('[data-role="docs-markdown-input"]') : null;
  if (!(input)) {
    return;
  }

  if (data && typeof data.markdown === "string") {
    input.value = data.markdown;
    return;
  }

  if (typeof data === "string") {
    input.value = data;
  }
}
module.exports.load = load;
